module.exports = __webpack_public_path__ + "img/1.135e3a6f.jpg";